import StaffMemberNotes from './StaffMemberNotes.container';

export default StaffMemberNotes;
